import { carvedRecordFor, type SignalSource } from './signal.js';
import type { VerifyResult } from './verification.js';

export interface VerificationModuleViewModel {
  carvedName: string;
  archiveName: string;
  archiveStatus: string;
  archiveExcerpt: string | null;
  outcome: 'TRUTH' | 'CONTRADICTION';
  stamp: string;
  lineState: 'hold' | 'sever';
}

const ARCHIVE_EXCERPT_MAX = 84;

const firstSentence = (text: string): string => {
  const compact = text.replace(/\s+/g, ' ').trim();
  const stop = compact.search(/[.!?]/);
  return stop >= 0 ? compact.slice(0, stop + 1) : compact;
};

const trimExcerpt = (text: string): string =>
  text.length <= ARCHIVE_EXCERPT_MAX
    ? text
    : `${text.slice(0, ARCHIVE_EXCERPT_MAX - 1).trimEnd()}…`;

const archiveStatus = (status: VerificationModuleViewModel['outcome']): string =>
  status === 'CONTRADICTION' ? 'STATUS: ALIVE' : 'STATUS: DECEASED';

export const buildVerificationModuleView = (
  signal: SignalSource,
  result: VerifyResult,
): VerificationModuleViewModel => {
  const record = carvedRecordFor(signal);
  const outcome = result.status === 'CONTRADICTION' ? 'CONTRADICTION' : 'TRUTH';
  return {
    carvedName: result.name,
    archiveName: result.name,
    archiveStatus: archiveStatus(outcome),
    archiveExcerpt: record.log ? trimExcerpt(firstSentence(record.log)) : null,
    outcome,
    stamp: outcome === 'CONTRADICTION' ? '✕ CONTRADICTION' : '✓ TRUTH',
    lineState: outcome === 'CONTRADICTION' ? 'sever' : 'hold',
  };
};
